/**
 * CORREGIR LA HORA DE UN MARCAJE DESDE LA FICHA UNICA (SUJ-T8 bloque 3; ajuste 2 de Josse, #17340).
 *
 * Reusa la correccion que ya existe en Asistencia: PATCH asistencia/{id}/correccion. La hora que
 * MARCO la persona se conserva; la correccion vive encima y deja fila en attendance_correcciones
 * (valor anterior, nuevo, quien y por que). La API exige gerente (RequireManager) y el motivo.
 *
 * QUIEN CORRIGE sale del token (nexo-api 304): este modulo NO arma corregidoPor. Mandarlo desde el
 * cliente pondria en el rastro lo que el navegador diga.
 *
 * Sin DOM: lo prueba scripts/check-ficha-correccion.mjs.
 */

const texto = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** Solo quien la API deja corregir ve el boton: admin o manager (RequireManager). */
export function puedeCorregir(rol) {
  return ['admin', 'manager'].includes(texto(rol).toLowerCase());
}

/** El motivo minimo, el mismo de la vista de Asistencia. */
export const MOTIVO_MINIMO = 5;

/** Los marcajes de un dia (AsistenciaDto), de la respuesta del listado, en orden de hora. */
export function marcasDelDia(res) {
  const c = res?.data;
  const d = c?.data ?? c;
  const items = Array.isArray(d?.items) ? d.items : Array.isArray(d) ? d : [];
  return items
    .map((m) => ({
      id: texto(m.id ?? m.Id),
      tipo: texto(m.tipo ?? m.Tipo).replace(/_/g, ' ') || 'marcaje',
      marcado: texto(m.timestampEvento ?? m.timestamp_evento),
      corregido: texto(m.timestampCorregido ?? m.timestamp_corregido ?? m.timestampEfectivo ?? '')
    }))
    .filter((m) => m.id)
    .sort((a, b) => (a.marcado < b.marcado ? -1 : a.marcado > b.marcado ? 1 : 0));
}

/** La hora local de Bogota (HH:MM) de un instante ISO. */
export function horaBogota(iso) {
  const t = Date.parse(texto(iso));
  if (!Number.isFinite(t)) return '';
  return new Date(t).toLocaleTimeString('es-CO', { timeZone: 'America/Bogota', hour: '2-digit', minute: '2-digit', hour12: false });
}

/** El dia (YYYY-MM-DD) en Bogota de un instante ISO: un marcaje de las 19:30 es de ESE dia, no del siguiente. */
export function diaBogota(iso) {
  const t = Date.parse(texto(iso));
  if (!Number.isFinite(t)) return '';
  return new Date(t).toLocaleDateString('en-CA', { timeZone: 'America/Bogota' });
}

/**
 * El instante ISO de una hora de Bogota en un dia (Colombia no tiene horario de verano: -05:00).
 * Asi 19:30 del 21-sep es 2026-09-22T00:30Z y no se corre de dia (el bug de toISOString de la vista).
 */
export function instanteBogota(dia, hora) {
  const d = texto(dia).slice(0, 10), h = texto(hora);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(d) || !/^\d{2}:\d{2}$/.test(h)) return '';
  const t = Date.parse(`${d}T${h}:00-05:00`);
  return Number.isFinite(t) ? new Date(t).toISOString() : '';
}

/**
 * Valida y arma el cuerpo de la correccion. Nunca incluye corregidoPor (lo pone la API del token).
 * @returns {{ ok: boolean, error: string, cuerpo: {timestampCorregido:string, motivo:string} | null }}
 */
export function correccionDe({ dia, hora, motivo, marcado }) {
  const ts = instanteBogota(dia, hora);
  if (!ts) return { ok: false, error: 'Escribe la hora como HH:MM.', cuerpo: null };
  const m = texto(motivo);
  if (m.length < MOTIVO_MINIMO) return { ok: false, error: `El motivo es obligatorio (mínimo ${MOTIVO_MINIMO} caracteres).`, cuerpo: null };
  if (marcado && Date.parse(marcado) === Date.parse(ts)) return { ok: false, error: 'Esa es la misma hora que ya tiene.', cuerpo: null };
  return { ok: true, error: '', cuerpo: { timestampCorregido: ts, motivo: m } };
}
